import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import { useCalibrationWorkspace } from '../CalibrationWorkspaceContext';
import { useCalibrate } from './useCalibrate';

const i18Path = 'performanceReview.calibration.saveBar';

export const CalibrationSaveBar: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);
  const {
    pendingChanges,
    conflicts,
    isEditable,
    clearPendingChanges,
    clearConflicts,
    refetchSession,
  } = useCalibrationWorkspace();
  const { calibrate, loading } = useCalibrate();
  const [reloading, setReloading] = useState(false);

  const hasChanges = pendingChanges.size > 0;
  const hasConflicts = conflicts.size > 0;

  if (!isEditable || (!hasChanges && !hasConflicts)) {
    return null;
  }

  const handleCancel = () => {
    clearPendingChanges();
    clearConflicts();
  };

  const handleSave = () => {
    calibrate();
  };

  const handleReload = async () => {
    setReloading(true);
    try {
      await refetchSession();
      clearConflicts();
    } finally {
      setReloading(false);
    }
  };

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 bg-white border-top shadow-lg p-3 d-flex justify-content-end align-items-center gap-2"
      style={{ zIndex: 1050 }}>
      {hasConflicts && !hasChanges && (
        <Button
          variant="outline-warning"
          disabled={reloading}
          onClick={handleReload}>
          {reloading && (
            <Spinner as="span" animation="border" size="sm" className="me-1" />
          )}
          {t('reloadChanges')}
        </Button>
      )}
      {hasChanges && (
        <>
          <Button
            variant="outline-secondary"
            disabled={loading}
            onClick={handleCancel}>
            {t('cancel')}
          </Button>
          <Button variant="primary" disabled={loading} onClick={handleSave}>
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-1"
              />
            )}
            {t('saveChanges', { count: pendingChanges.size })}
          </Button>
        </>
      )}
    </div>
  );
};
